import { onMounted, onUnmounted, ref } from 'vue';
import { emitter } from '@/utils';
import { EVENT_NAMES } from '@/constants';

/**
 * 水印弹窗 hook
 *
 * 在 App.vue 中统一管理 WatermarkDialog 的显隐状态。
 * 其他模块通过 emitter.emit(WATERMARK_DIALOG_OPEN, { resolve? }) 打开弹窗，
 * 传入可选的 resolve 回调，在用户点击"保存设置"后执行。
 */
export function useWatermarkDialog() {
  const isWatermarkDialogOpen = ref(false);
  let watermarkExportResolve: (() => void) | null = null;

  function handleWatermarkSaved() {
    watermarkExportResolve?.();
    watermarkExportResolve = null;
  }

  function handleWatermarkClosed() {
    watermarkExportResolve = null;
  }

  function onWatermarkDialogOpen(payload: unknown) {
    const p = payload as { resolve?: () => void } | undefined;
    watermarkExportResolve = p?.resolve ?? null;
    isWatermarkDialogOpen.value = true;
  }

  onMounted(() => {
    emitter.on(EVENT_NAMES.WATERMARK_DIALOG_OPEN, onWatermarkDialogOpen);
  });

  onUnmounted(() => {
    emitter.off(EVENT_NAMES.WATERMARK_DIALOG_OPEN, onWatermarkDialogOpen);
  });

  return {
    isWatermarkDialogOpen,
    handleWatermarkSaved,
    handleWatermarkClosed
  };
}
